import React from 'react';

import LocaleMessage from '~/components/LocaleMessage';

import {
    formatCleaningDuration,
    formatCleaningReportCreateDateTime,
    getCleaningReportTaskStartTime,
    getCleaningModeLabel,
    getCleaningTaskStatusLabel,
} from '../CleaningReportsDashboard/cleaningReportUtils';
import {
    calculateEfficiency,
    formatEfficiency,
} from './Efficiency/EfficiencyUtils';

/**
 * Linhas da tabela de tarefas de limpeza (pluginspace).
 * @param {object} props
 * @param {Array} props.rows
 * @param {string} props.localeCode
 * @param {(row: object) => void} [props.onRowClick]
 */
export default function CleaningTaskTableRows({
    rows,
    localeCode,
    onRowClick,
}) {
    if (rows.length === 0) {
        return (
            <tr>
                <td colSpan={7} className="text-center text-muted">
                    <LocaleMessage msg="label.no_data" />
                </td>
            </tr>
        );
    }

    return rows.map((row, idx) => {
        const rid =
            row.report_id != null ? String(row.report_id) : `row-${idx}`;
        const robotIdPart = row._robot && row._robot.id ? row._robot.id : 'x';
        const rkey = `${robotIdPart}-${rid}-${idx}`;
        const canOpen =
            row.report_id != null &&
            String(row.report_id).trim() !== '' &&
            row._robot &&
            row._robot.id;

        return (
            <tr
                key={rkey}
                onClick={
                    onRowClick && canOpen ? () => onRowClick(row) : undefined
                }
                style={{
                    cursor: canOpen ? 'pointer' : 'default',
                }}
            >
                <td>
                    {row._robot
                        ? `${row._robot.name || ''} (${row._robot.code || ''})`
                        : '—'}
                </td>
                <td>{row.task_name}</td>
                <td>{formatCleaningDuration(row.clean_time)}</td>
                <td>
                    {formatEfficiency(
                        calculateEfficiency(row.clean_area, row.clean_time)
                    )}
                </td>
                <td>{Number(row.clean_area).toFixed(2)}</td>
                <td>
                    {formatCleaningReportCreateDateTime(
                        getCleaningReportTaskStartTime(row)
                    )}
                </td>
                <td>{getCleaningModeLabel(row.mode, localeCode)}</td>
                <td>{getCleaningTaskStatusLabel(row.status, localeCode)}</td>
            </tr>
        );
    });
}
